import apiClient from './client';
import {
  ParseIndexChannelRequest,
  ParseIndexChannelResponse,
  ImportIndexChannelRequest,
  ImportIndexChannelResponse,
} from '@/types/indexChannel';

/**
 * Parse index channel to extract library sections
 */
export const parseIndexChannel = async (
  request: ParseIndexChannelRequest
): Promise<ParseIndexChannelResponse> => {
  const response = await apiClient.post<ParseIndexChannelResponse>(
    '/index-channel/parse',
    request
  );
  return response.data;
};

/**
 * Import library sections from parsed index channel
 */
export const importIndexChannel = async (
  request: ImportIndexChannelRequest
): Promise<ImportIndexChannelResponse> => {
  const response = await apiClient.post<ImportIndexChannelResponse>(
    '/index-channel/import',
    request
  );
  return response.data;
};
